import { DefaultLayout } from '@fondationcss/ui';
import PlayLayout from '@/views/play/play-layout.vue';

export const getCustomRoutes = () => [
  {
    path: '/',
    component: DefaultLayout,
    meta: { title: "Kwiz" },
    children: [
      {
        name: 'default-home',
        path: '',
        redirect: '/quizzes'
      },
      {
        name: 'quizzes',
        path: 'quizzes',
        component: () => import('@/views/quizzes/quizzes-list.vue'),
        meta: { permission: 'Kwiz.Quizzes.View' }
      },
      {
        name: 'quiz-create',
        path: 'quizzes/create',
        component: () => import('@/views/quizzes/quiz-form.vue'),
        meta: { permission: 'Kwiz.Quizzes.Create' }
      },
      {
        name: 'quiz-edit',
        path: 'quizzes/:id/edit',
        component: () => import('@/views/quizzes/quiz-form.vue'),
        meta: { permission: 'Kwiz.Quizzes.Create' }
      },
      {
        name: 'sessions',
        path: 'sessions',
        component: () => import('@/views/sessions/sessions-list.vue'),
        meta: { permission: 'Kwiz.Quizzes.View' }
      },
      {
        name: 'session-host',
        path: 'sessions/:id',
        component: () => import('@/views/sessions/session-host.vue'),
        meta: { permission: 'Kwiz.Quizzes.View' }
      },
      {
        name: 'reports',
        path: 'reports',
        component: () => import('@/views/reports/reports-list.vue'),
        meta: { permission: 'Kwiz.Quizzes.View' }
      },
      {
        name: 'report-detail',
        path: 'reports/:id',
        component: () => import('@/views/reports/report-detail.vue'),
        meta: { permission: 'Kwiz.Quizzes.View' }
      },
    ]
  },
  {
    path: '/play',
    component: PlayLayout,
    meta: { title: "Jouer" },
    children: [
      {
        name: 'join-game',
        path: '',
        component: () => import('@/views/play/join-game.vue'),
      },
      {
        name: 'join-game-pin',
        path: ':pin',
        component: () => import('@/views/play/join-game.vue'),
      },
      {
        name: 'player-lobby',
        path: 'lobby/:sessionId',
        component: () => import('@/views/play/player-lobby.vue'),
      },
      {
        name: 'player-game',
        path: 'game/:sessionId',
        component: () => import('@/views/play/player-game.vue'),
      },
    ]
  },
];
